// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_updatePaymentCard(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["PaymentCardUpdated"]);
}

let variablesConverter = {"updatePaymentCardInput":{},"__root":{"input":{"r":"updatePaymentCardInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"updatePaymentCard_PaymentCardUpdated_account":{"f":""},"updatePaymentCard":{"u":"response_updatePaymentCard"}}};

let wrapResponseConverterMap = {
  response_updatePaymentCard: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"updatePaymentCard_PaymentCardUpdated_account":{"f":""},"updatePaymentCard":{"u":"response_updatePaymentCard"}}};

let responseConverterMap = {
  response_updatePaymentCard: unwrap_response_updatePaymentCard
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SetAccountCardDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updatePaymentCard",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountV5",
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BillingSettingsPagePaymentCard_accountV5"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "PaymentCardUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetAccountCardDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updatePaymentCard",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountV5",
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentCard",
                    "kind": "LinkedField",
                    "name": "card",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "expMonth",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "expYear",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "brand",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastFour",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "PaymentCardUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f722b18ea30f60c599de9b26f89c2693",
    "id": null,
    "metadata": {},
    "name": "SetAccountCardDialogMutation",
    "operationKind": "mutation",
    "text": "mutation SetAccountCardDialogMutation(\n  $input: UpdatePaymentCardInput!\n) {\n  updatePaymentCard(input: $input) {\n    __typename\n    ... on PaymentCardUpdated {\n      account {\n        ...BillingSettingsPagePaymentCard_accountV5\n        nodeId\n      }\n    }\n  }\n}\n\nfragment BillingSettingsPagePaymentCard_CardDetails_accountCard on PaymentCard {\n  expMonth\n  expYear\n  name\n  ...PaymentCardLogo_paymentCard\n  ...PaymentCardMaskedNumber_paymentCard\n}\n\nfragment BillingSettingsPagePaymentCard_accountV5 on AccountV5 {\n  card {\n    ...BillingSettingsPagePaymentCard_CardDetails_accountCard\n  }\n}\n\nfragment PaymentCardLogo_paymentCard on PaymentCard {\n  brand\n}\n\nfragment PaymentCardMaskedNumber_paymentCard on PaymentCard {\n  brand\n  lastFour\n}\n"
  }
};
})());

let wrap_response_updatePaymentCard = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updatePaymentCard = unwrap_response_updatePaymentCard;
exports.wrap_response_updatePaymentCard = wrap_response_updatePaymentCard;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
